export const ERROR_FIELDS = `
	error {
		fieldValue
		errorMessage
	}
`;
